
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import TextRedaction from "../pages/text-redaction/page";
import FileRedaction from "../pages/file-redaction/page";
import ImageRedaction from "../pages/image-redaction/page";
import VideoRedaction from "../pages/video-redaction/page";
import Examples from "../pages/examples/page";
import About from "../pages/about/page";
import Damaya from "../pages/damaya/page";
import Pricing from "../pages/pricing/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import TermsOfService from "../pages/terms-of-service/page";

const pageRoutes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/text-redaction",
    element: <TextRedaction />,
  },
  {
    path: "/file-redaction",
    element: <FileRedaction />,
  },
  {
    path: "/image-redaction",
    element: <ImageRedaction />,
  },
  {
    path: "/video-redaction",
    element: <VideoRedaction />,
  },
  {
    path: "/examples",
    element: <Examples />,
  },
  {
    path: "/damaya",
    element: <Damaya />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/pricing",
    element: <Pricing />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms-of-service",
    element: <TermsOfService />,
  },
];

// Every page exists twice: at its Chinese path and under /en (see src/lib/locale.ts).
const routes: RouteObject[] = [
  ...pageRoutes,
  ...pageRoutes.map(route => ({ ...route, path: route.path === "/" ? "/en" : `/en${route.path}` })),
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
